import { ActionBar, ActionBarElementType, Button, ButtonVariant } from '@dreryk/react-components';

import { visitActionBarTranslationKeys } from '../../../../translations';
import { useVisitPushBack } from '../../../../visit/form/visitForm.hooks';

export const SaveAndClosePrescriptionVisitAction = (): JSX.Element => {
   const pushBack = useVisitPushBack();

   return (
      <ActionBar.Portal elementType={ActionBarElementType.PRIMARY}>
         <Button
            testId={'saveAndCloseVisit'}
            label={visitActionBarTranslationKeys.confirmLater}
            variant={ButtonVariant.SECONDARY}
            onClick={pushBack}
            compact
            nowrap
         />
      </ActionBar.Portal>
   );
};
